<button mat-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
  <span>SAVE</span>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngIf="isDispensed; else defaultSaveOptions">
    <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('RE-STYLE')">
      RE-STYLE
    </button>
    <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('RETURN')">
      RETURN
    </button>
  </ng-container>
  <ng-template #defaultSaveOptions>
    <ng-container *ngIf="variant === 'repair'; else orderSaveOptions">
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED')">
        REPAIR
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        WARRANTY
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        SAVE/HOLD
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        VOID
      </button>
    </ng-container>
    <ng-template #orderSaveOptions>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED FRAME')">
        ORDERED FRAME
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED ON APPROVAL')">
        ORDERED ON APPROVAL
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SEND TO STACK')">
        SEND TO STACK
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE/HOLD')">
        SAVE / HOLD
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE/QUOTE')">
        SAVE QUOTE
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ADD TO CART')">
        ADD TO CART
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('VOID')">
        VOID
      </button>
    </ng-template>
  </ng-template>
</mat-menu>
